import { useState } from "react";
import { Loader2 } from "lucide-react";

const REASONS = ["Too expensive", "Not using it enough", "Missing a feature I need", "Switching to another tool", "Just taking a break", "Other"];

export const CancelFeedbackModal = ({ open, onClose, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const submit = async () => {
    setBusy(true);
    try { await onConfirm({ reason: reason || null, comment: comment.trim() || null }); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-zinc-900/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="cancel-feedback-modal">
      <div className="bg-white w-full max-w-md p-6 sm:p-8">
        <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#FF3B30] mb-2">Switching to Entry</div>
        <h2 className="text-2xl font-black tracking-tighter mb-1">Before you go — what's the main reason?</h2>
        <p className="text-xs text-zinc-500 mb-5">One tap helps us improve. Your paid subscription will be canceled.</p>
        <div className="space-y-2 mb-4">
          {REASONS.map((r, i) => (
            <button key={r} onClick={() => setReason(r)} data-testid={`cancel-reason-${i}`}
              className={`w-full text-left px-4 py-3 text-sm border transition-colors ${reason === r ? "border-[#0033FF] bg-[#0033FF]/5 font-bold" : "border-zinc-200 hover:border-zinc-400"}`}>
              {r}
            </button>
          ))}
        </div>
        <textarea data-testid="cancel-comment-input" value={comment} onChange={(e) => setComment(e.target.value)} maxLength={1000} rows={2}
          placeholder="Anything else? (optional)" className="w-full px-3 py-2 border border-zinc-300 text-sm focus:outline-none focus:border-[#0033FF] mb-5" />
        <div className="flex gap-3">
          <button onClick={onClose} disabled={busy} data-testid="cancel-feedback-keep"
            className="flex-1 border border-zinc-900 px-4 py-3 text-xs font-bold uppercase tracking-wider hover:bg-zinc-900 hover:text-white">Keep my plan</button>
          <button onClick={submit} disabled={busy} data-testid="cancel-feedback-confirm"
            className="flex-1 bg-[#FF3B30] text-white px-4 py-3 text-xs font-bold uppercase tracking-wider hover:bg-zinc-900 disabled:opacity-50 inline-flex items-center justify-center gap-2">
            {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Switch to Entry
          </button>
        </div>
      </div>
    </div>
  );
};
